exports.Daterangepicker = require('./lib/daterangepicker/daterangepicker.module').Daterangepicker;
exports.DaterangePickerComponent = require('./lib/daterangepicker/daterangepicker.component').DaterangePickerComponent;
exports.DaterangepickerConfig = require('./lib/daterangepicker/config.service').DaterangepickerConfig;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-daterangepicker/index.js
// module id = 574
// module chunks = 9